module.exports = __webpack_public_path__ + "img/introducepinxdetail_bodyimage02.a455dd6e.jpg";